module.exports = __webpack_public_path__ + "img/375_banner_1.1930af09.jpg";